// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YRGYT","comment":"styles_comment__2P3Is"};